import { create } from 'zustand';

interface BasicState {
  captionsEnabled: boolean;
  translationData: any;
  tourConfigs: any;
  forceShowPathSwitchMobileModal: boolean;
  audioConfigs: {
    muted: boolean;
    volume: number;
    captionsEnabled: boolean;
  };
}

interface BasicActions {
  setCaptionsEnabled: (enabled: boolean) => void;
  setTranslationData: (data: any) => void;
  setTourConfigs: (configs: any) => void;
  setForceShowPathSwitchMobileModal: (show: boolean) => void;
  setAudioConfigs: (configs: any) => void;
}

export const useBasicStore = create<BasicState & BasicActions>((set) => ({
  // State
  captionsEnabled: true,
  translationData: null,
  tourConfigs: {},
  forceShowPathSwitchMobileModal: false,
  audioConfigs: {
    muted: false,
    volume: 0.5,
    captionsEnabled: true,
  },

  // Actions
  setCaptionsEnabled: (enabled) => set({ captionsEnabled: enabled }),
  setTranslationData: (data) => set({ translationData: data }),
  setTourConfigs: (configs) => set({ tourConfigs: configs }),
  setForceShowPathSwitchMobileModal: (show) => set({ forceShowPathSwitchMobileModal: show }),
  setAudioConfigs: (configs) => set({ audioConfigs: configs }),
}));
